// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerD_TheComp__Yf_Qm"};